import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { ToastrModule } from 'ngx-toastr';

import { CoreServicesModule, CORE_CONFIGURATION } from '@pm-ui/core-services';
// import {pmServicesModule  } from '@pm-ui/pm-services';
import { pmComponentsModule } from '@pm-ui/pm-components';

import { ConfigurationFactory, DateFormatsFactory } from './factories';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
//import { MarkAsteriskDirective } from './directives/mark-asterisk.directive';

import { NgxSpinnerModule } from "ngx-spinner";
import { BnNgIdleService } from 'bn-ng-idle';
import { MatDialogModule } from '@angular/material/dialog';
import { AppMaterialModule } from './modules/app-material.module';
import { LockandDeleteFilePopupComponent } from './lockand-delete-file-popup/lockand-delete-file-popup.component';
import { QuillModule } from 'ngx-quill';
import './quill-setup'; // Sets window.Quill and registers ImageResize via require() (not hoisted)


@NgModule({
  declarations: [AppComponent, LockandDeleteFilePopupComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    RouterModule,
    AppRoutingModule,
    CoreServicesModule,
    pmComponentsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    AppMaterialModule,
    // DragDropModule
    QuillModule.forRoot({
      bounds: 'body'
    })
  ],
  providers: [
    BnNgIdleService,
    { provide: CORE_CONFIGURATION, useFactory: ConfigurationFactory },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: DateFormatsFactory },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
